/**
 * This module was automatically generated by `ts-interface-builder`
 */
import * as t from "ts-interface-checker";
// tslint:disable:object-literal-key-quotes

export const GristTable = t.iface([], {
  "table_name": t.union("string", "null"),
  "column_metadata": t.array("GristColumn"),
  "table_data": t.array(t.array("any")),
});

export const GristTables = t.iface([], {
  "tables": t.array("GristTable"),
});

export const GristColumn = t.iface([], {
  "id": "string",
  "type": "string",
});

export const APIType = t.enumtype({
  "ImportSourceAPI": 0,
  "ImportProcessorAPI": 1,
  "ParseOptionsAPI": 2,
  "ParseFileAPI": 3,
});

const exportedTypeSuite: t.ITypeSuite = {
  GristTable,
  GristTables,
  GristColumn,
  APIType,
};
export default exportedTypeSuite;
